export default __webpack_public_path__ + "static/media/Navakij.022d1124.png";